import {Injectable} from '@angular/core';
import {Headers, Http, Response} from '@angular/http';
import {webapi} from '../../shared/my-constants';
import 'rxjs/add/operator/toPromise';

@Injectable()
export class IpdChargesService {
    private DeletetpathByCsIdRecord = webapi + 'tpath_bs/delete/byCsId/';
    private CancelTpathByCsIdRecord = webapi + 'tpath_bs/cancel/byCsId/';
    private GetTpathByCsIdRecord = webapi + 'tpath_bs/bycsid/';
    private headers = new Headers({'Content-Type': 'application/json'});

    constructor(private http: Http) {
    }

    canceltpathByCsIdRecord(id: any, rem: any) {
        console.log('rem', rem);
        console.log('rem json', JSON.stringify(rem));
        return this.http.put(this.CancelTpathByCsIdRecord + id, JSON.stringify(rem), {headers: this.headers})
            .toPromise()
            .then(response => response.json())
            .catch(this.handleError);
    }

    getTpathByCsIdRecord(id: any) {
        return this.http.put(this.GetTpathByCsIdRecord + id, {headers: this.headers})
            .toPromise()
            .then(response => response.json())
            .catch(this.handleError);
    }

    private handleError(error: Response | any) {
        return Promise.reject(error.message || error);
    }
}



// WEBPACK FOOTER //
// D:/CODE_REPOSITORIES/HIMS/HIMS_FRONTEND/src/app/billing/ipd-charges/ipd-charges.service.ts